import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Divider from "@mui/material/Divider";
import CCOHeadline from "../../fundamentals/CCOHeadline";
import CCORichText from "../../fundamentals/CCORichText/CCORichText";
import {CmCollectionType, CmTeasableType, CmVideoType} from "../../types";
import C041Video from "../C041Video/C041Video";
import CCOPicture from "../../fundamentals/CCOPicture";
import C001Accordion from "../C001Accordion/C001Accordion";
import C003Download from "../C003Download/C003Download";
import CCOContainer from "../../fundamentals/CCOContainer";
import CCOComponentWrapper from "../../fundamentals/CCOComponentWrapper";
import {RichTextElement} from "../../fundamentals/CCORichText/CCORichTextHelper";
import {getContainerWidth} from "../../../utility/componentUtil";

export interface Props {
    cmCollection: CmCollectionType,
    layoutSettings?: any,
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`sos-tabpanel-${index}`}
            aria-labelledby={`sos-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{py: 3}}>
                    <Typography component="div">{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `sos-tab-${index}`,
        'aria-controls': `sos-tabpanel-${index}`,
    };
}


function C004Tabs(props: Props) {
    const [value, setValue] = React.useState(0);
    const containerWidth = getContainerWidth(props.layoutSettings?.contentWidth);

    /*
        In Storybook muss für die Tabs-Komponente variant="standard" verwendet werden, um Fehler durch DOM-Messungen in MUI zu vermeiden.
        scrollable` benötigt offsetHeight, was in der isolierten Storybook-Umgebung anscheinend fehlt.
    */
    const isStorybook = !!process.env.STORYBOOK;

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return <CCOComponentWrapper>

        <CCOHeadline id={props.cmCollection.id}
                     metadataId={props.cmCollection.id}
                     headline={props.cmCollection.teaserTitle}
                     type='componenthead'
                     propertyName='properties.teaserTitle'
                     subtextPropertyName='properties.teaserText'
                     subtext={props.cmCollection.teaserText?.textAsTree}/>
        <CCOContainer width={containerWidth}>
            <Box sx={{width: '100%'}}>
                <Tabs value={value} onChange={handleChange}
                      variant={isStorybook ? "standard" : "scrollable"} scrollButtons
                      allowScrollButtonsMobile
                      sx={{
                          '& .MuiTabScrollButton-horizontal.Mui-disabled': {
                              display: 'none'
                          }
                      }}>
                    {
                        props.cmCollection.items?.map(item => item as CmTeasableType).map((teasableItem: CmTeasableType, index: number) =>
                            <Tab key={index} label={teasableItem.title} {...a11yProps(index)} sx={{
                                         color: 'text.primary',
                                         textTransform: 'none',
                                         fontSize: '18px',
                                     }}/>)
                    }
                </Tabs>
                <Divider/>
                {
                    props.cmCollection.items?.map((i: any, index: number) =>
                                                      <TabPanel key={index} value={value}
                                                                index={index}>
                                                          {/*------ Article Text ------*/}
                                                          {i.teaserText ?
                                                              <CCORichText metadataId={i.id}
                                                                           propertyName={'properties.teaserText'}
                                                                           textAsTree={i.teaserText!.textAsTree as RichTextElement}/> :
                                                              null}
                                                          {/*end ------ Article Text ------*/}

                                                          {/*------ Related Content ------*/}
                                                          {i.related?.map((relatedContent: any,
                                                                           contentIndex: number) =>
                                                                              relatedContent.type ===
                                                                              "CMCollection" ?
                                                                                  (relatedContent.viewtype ===
                                                                                   "c001_accordion") ?
                                                                                      <C001Accordion
                                                                                          key={contentIndex}
                                                                                          cmCollection={relatedContent}></C001Accordion> :
                                                                                      (relatedContent.viewtype ===
                                                                                       "c003_download") ?
                                                                                          <C003Download
                                                                                              key={contentIndex}
                                                                                              cmCollection={relatedContent}></C003Download> :
                                                                                          null
                                                                                  : null
                                                          )}
                                                          {/*end ------ Related Content ------*/}

                                                          {/*------ Media: Videos and Pictures ------ */}
                                                          {i.media?.map(
                                                              (media: any, mediaIndex: number) =>
                                                                  media.type === "CMVideo" ?
                                    <C041Video key={mediaIndex} video={{dataUrl: media.dataUrl} as CmVideoType} noContainer></C041Video> :
                                                                      media.type === "CMPicture" ?
                                                                          <CCOPicture
                                                                              key={mediaIndex}
                                                                              name={media.name}
                                                                              picture={media}
                                                                              width='540'
                                                                              height='540'
                                                                              orientation='portrait_ratio1x1'></CCOPicture> :
                                                                          null
                                                          )}
                                                          {/*end ------ Media: Videos and Pictures ------*/}
                                                      </TabPanel>
                    )
                }
            </Box>
        </CCOContainer>
    </CCOComponentWrapper>
}

export default C004Tabs